import { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { Student } from "../../types/user";
import { handleApiError } from "../../utils/handleApiError";
import { fetchStudents } from "../../services/api/users.api";

const AutocompleteStudents = ({
  student,
  handleSelectedStudent,
  setError,
  size = "small",
}: {
  student: any;
  handleSelectedStudent: any;
  setError: any;
  size?: "small" | "medium";
}) => {
  const [students, setStudents] = useState<Student[]>([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true); // Track if more data is available

  const fetchApi = async (
    page: number,
    rpp: number,
    data = "",
    reset = false
  ) => {
    setLoading(true);
    fetchStudents(rpp, page, data)
      .then((res) => {
        console.log("STUDENTS:", res.data);
        const newStudents = res.data.data.students || [];

        setStudents(
          (prev) => (reset ? newStudents : [...prev, ...newStudents]) // Append if not resetting
        );
        setHasMore(newStudents.length > 0);
        console.log("STUDENTS:", newStudents.length > 0);

        // setData(res.data.data.students || []);
        // setTotalRows(res.data.data.total_count);
      })
      .catch((e) => {
        handleApiError(e, setError);
      })
      .finally(() => setLoading(false));
  };

  // Fetch students from API
  const loadStudents = async (reset = false) => {
    if (loading) return;
    setLoading(true);

    try {
      await fetchApi(page, 20, inputValue, reset);
    } catch (error) {
      console.error("Error fetching students:", error);
    }

    setLoading(false);
  };

  // Load more students on scroll
  const handleScroll = (event: any) => {
    const listbox = event.currentTarget;
    if (listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 10) {
      if (hasMore) {
        setPage((prev) => prev + 1);
      }
    }
  };

  // Fetch students on mount or input change
  useEffect(() => {
    setPage(1);
    loadStudents(true);
  }, [inputValue]);

  // Fetch next page when page changes
  useEffect(() => {
    if (page > 1) loadStudents();
  }, [page]);

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && students.length > 0) {
      handleSelectedStudent(students[0]); // Select first option
    }
  };

  return (
    <Autocomplete
      size={size}
      fullWidth
      options={students}
      value={student}
      onChange={(event, newValue: any) => handleSelectedStudent(newValue)}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      onKeyDown={handleKeyDown}
      getOptionLabel={(option) => option._id || ""}
      renderOption={(props, option) => (
        <li {...props} key={option._id}>
          {option._id}
        </li>
      )}
      renderInput={(params) => (
        <TextField {...params} label='Filter by Student' />
      )}
      ListboxProps={{ onScroll: handleScroll }}
      loading={loading}
      loadingText={<CircularProgress size={24} />}
    />
  );
};

export default AutocompleteStudents;
